import React from 'react';
import { ChevronRight, FileCheck } from 'lucide-react';
import { Link } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import { EvaluationSummary } from '@/types';

interface EvaluationListItemProps {
    evaluation: EvaluationSummary;
}

const EvaluationListItem: React.FC<EvaluationListItemProps> = ({ evaluation }) => {
    const { t } = useTranslation();

    return (
        <Link
            href={`/evaluations/${evaluation.id}/`}
            className="group flex items-center justify-between rounded-lg border border-transparent px-4 py-3 transition-all duration-150 hover:border-sky-100 hover:bg-sky-50/70"
        >
            <div className="flex items-center space-x-3">
                <FileCheck size={16} className="text-sky-500" />
                <div>
                    <h4 className="font-medium text-gray-900 transition-colors group-hover:text-sky-700">
                        {evaluation.title}
                    </h4>
                    <p className="text-xs text-sky-700/75">
                        {t('course.evaluation')}
                    </p>
                </div>
            </div>
            <ChevronRight
                size={16}
                className="text-sky-300 transition-colors group-hover:text-sky-500"
            />
        </Link>
    );
};

export default EvaluationListItem;
